module.exports = __webpack_public_path__ + "img/achievement-course9.d3b06b35.png";